import React, { FC, useMemo } from 'react';

import { Form, Formik } from 'formik';

// components
import BasicModal from '../../../../../../../components/modals/basicModal';
import AampeAttributeDropdown from '../../../../../../../components/shared/AampeAttributeDropdown/AampeAttributeDropdown';
import styled from 'styled-components';

// constant
import aampeTheme from '../../../../../../../constants/aampeTheme';
import { ModalHeaderStyle } from '../../../../../../../views/attributes/constants';
import { validationSchema } from '../constants';

// models
import { AttributePlaceholderElement } from '../../../../../../../models/editor.model';
import { AttributePlaceholderFormikValues } from '../../../../../../../models/formula.model';

import AttributeDefaultValueInput from './AttributeDefaultValueInput';
import AttributePlaceholderModalAction from './AttributePlaceholderModalAction';

interface AttributePlaceholderModalProps {
    handleClose: () => void;
    insertUserAttributePlaceholder?: (
        defaultValue: string,
        userAttribute: string,
    ) => void;
    editUserAttributePlaceholder?: (
        id: string,
        defaultValue: string,
        attributeName: string,
    ) => void;
    userAttributeData?: AttributePlaceholderElement;
}
const AttributePlaceholderModal: FC<AttributePlaceholderModalProps> = ({
    handleClose,
    insertUserAttributePlaceholder,
    editUserAttributePlaceholder,
    userAttributeData,
}) => {
    const initialValues = useMemo<AttributePlaceholderFormikValues>(
        () => ({
            userAttribute: userAttributeData?.attributeName ?? '',
            defaultValue: userAttributeData?.defaultValue ?? '',
        }),
        [userAttributeData],
    );

    const isUpdating = useMemo<boolean>(
        () => !!userAttributeData,
        [userAttributeData],
    );

    return (
        <BasicModal
            width="512px"
            childContainerStyle={{
                padding: aampeTheme.spacing4(4, 8, 8, 8),
            }}
            header={`${isUpdating ? 'Update' : 'Add'} user attribute`}
            handleClose={handleClose}
            headerStyle={ModalHeaderStyle}
        >
            <Formik
                onSubmit={(values) => {
                    if (userAttributeData) {
                        editUserAttributePlaceholder?.(
                            userAttributeData.id,
                            values.defaultValue,
                            values.userAttribute,
                        );
                    }
                    insertUserAttributePlaceholder?.(
                        values.defaultValue,
                        values.userAttribute,
                    );
                    handleClose();
                }}
                validationSchema={validationSchema}
                initialValues={initialValues}
                validateOnMount
            >
                <StyledForm>
                    <AampeAttributeDropdown />
                    <AttributeDefaultValueInput />
                    <AttributePlaceholderModalAction
                        handleClose={handleClose}
                        isUpdating={isUpdating}
                    />
                </StyledForm>
            </Formik>
        </BasicModal>
    );
};

const StyledForm = styled(Form)({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(4),
});

export default AttributePlaceholderModal;
